<template>
  <div>
    <OnboardingTopBar />
    <!-- step 1 -->
    <div class="parent-box">
      <div class="heading">
        <img width="200" :src="require('@/assets/img/goal.svg')" />
        <h2 class="login-title">You've been added to our Wait List!</h2>
        <p class="text">
          Thank you for your interest in our IPP service. Unfortunately, the
          service is currently unavailable at the location you have selected.
        </p>
        <p class="text">
          We have added you to our waitlist and will notify you as soon as the
          IPP service becomes available in your chosen location.
        </p>
        <p class="text">
          Thank you for choosing Arnergy.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import OnboardingTopBar from "@/components/OnboardingTopBar.vue";

export default {
  components: {
    OnboardingTopBar
  },
  computed: {},
  created() {
    this.locations = locationsData;
    this.ippLocations = ippLocationsData;
  },

  data() {
    return {};
  },
  methods: {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
.heading {
  max-width: 600px;
  margin: 0 auto;
  text-align: center;
}
.text {
  text-align: center;
  margin: 20px auto;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/onboarding/ipp/waitlist/index.vue